// The brightness curve is expected as an object map { hour: value }, e.g.
// { 0: 0, 6: 60, 12: 90, 18: 70, 24: 0 } (see NewDisplay's default).
//
// Some legacy/corrupt display records instead store it as a (stringified) array
// of [hour, value] pairs, e.g. "[[0,0],[6,60],[12,95],[18,80],[24,05]]" — note
// the `05` is not even valid JSON. The BrightnessCurve component only understands
// the object form, so such records render as an empty curve.
//
// This helper coerces whatever we get into the canonical object. For a value that
// is already an object map it is a no-op, so normal displays are unaffected.
export function normalizeBrightnessCurve (raw) {
  let curve = raw

  if (typeof curve === 'string') {
    try {
      curve = JSON.parse(curve)
    } catch (e) {
      try {
        // tolerate invalid JSON numbers with leading zeros, e.g. `05` -> `5`
        curve = JSON.parse(curve.replace(/\b0+(\d)/g, '$1'))
      } catch (e2) {
        curve = null
      }
    }
  }

  // array of [hour, value] pairs -> { hour: value }
  if (Array.isArray(curve)) {
    const obj = {}
    for (const pair of curve) {
      if (Array.isArray(pair) && pair.length >= 2) {
        obj[Number(pair[0])] = Number(pair[1])
      }
    }
    curve = obj
  }

  // anything we still couldn't make sense of falls back to a sane default
  if (!curve || typeof curve !== 'object' || Array.isArray(curve) || Object.keys(curve).length === 0) {
    curve = { 0: 0, 6: 60, 12: 90, 18: 70, 24: 0 }
  }

  return curve
}
